import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politica-privacidad-uso',
  templateUrl: './politica-privacidad-uso.component.html',
  styleUrls: ['./politica-privacidad-uso.component.css']
})
export class PoliticaPrivacidadUsoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
